import { Identificable } from 'shared/types/commonView';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import { ensureArray } from 'shared/utils/array';

/**
 * Protocol starts fully expanded. Every consecutive item run is virtualized;
 * collapsed sections unmount via accordion.
 */
export const DEFAULT_EXPAND_ALL_CHECKLIST = true;

export const resolveChecklistItemIdAsIs: (checklistItemId: string) => string =
  (id) => id;

export function toLabelledEntity(value: Identificable & { label: string }): LabelledEntity {
  return {
    _id: value._id,
    label: value.label,
  };
}

export function contractsExtractor(
  contracts: HashMap<LabelledEntity[]>,
  companies: readonly LabelledEntity[] | LabelledEntity | undefined
): LabelledEntity[] | undefined {
  const normalizedCompanies = ensureArray(companies);
  if (normalizedCompanies.length === 0) return undefined;
  
  const uniqueContracts = new Map<string, LabelledEntity>();
  normalizedCompanies.forEach((company) => {
    const companyContracts = contracts[company._id] ?? [];
    companyContracts.forEach((contract) => {
      uniqueContracts.set(contract._id, contract);
    });
  });
  
  const result = Array.from(uniqueContracts.values());
  return result.length > 0 ? result : undefined;
}

export function controlledPartiesExtractor(
  companiesOnSite: HashMap<LabelledEntity[]>,
  sites: readonly LabelledEntity[] | LabelledEntity | undefined
): LabelledEntity[] | undefined {
  const normalizedSites = ensureArray(sites);
  if (normalizedSites.length === 0) return undefined;
  
  const uniqueCompanies = new Map<string, LabelledEntity>();
  normalizedSites.forEach((site) => {
    const siteCompanies = companiesOnSite[site._id] ?? [];
    siteCompanies.forEach((company) => {
      uniqueCompanies.set(company._id, company);
    });
  });
  
  const result = Array.from(uniqueCompanies.values());
  return result.length > 0 ? result : undefined;
}
